import React, { useState } from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

// Custom Hook
import useScroll from "../components/useScroll";
import useActiveLink from "../components/useActiveLink";

// Image
import logoLight from "../assets/images/logo-light.png";
import logoDark from "../assets/images/logo-dark.png";

const NavBar = () => {
  const navClass = useScroll();
  const { activeLink } = useActiveLink(".navbar-nav li.active");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <React.Fragment>
      <nav
        className={
          "navbar navbar-expand-lg fixed-top navbar-custom tarnsperant-sticky " +
          navClass
        }
        id="navbar"
      >
        <Container fluid className="navbar-wrapper">
          <Link className="navbar-brand logo" to="#">
            <img src={logoLight} className="logo-light" alt="" height="50" />
            <img src={logoDark} className="logo-dark" alt="" height="50" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggle}
          >
            <i className="mdi mdi-menu"></i>
          </button>
          <Navbar.Collapse id="navbarSupportedContent" in={isOpen}>
            <ul className="navbar-nav ms-lg-4 navbar-center d-flex w-100 align-items-start align-items-lg-center">
              <li
                className={`nav-item ${activeLink === "/home" ? "active" : ""}`}
              >
                <Nav.Link href="#home">Home</Nav.Link>
              </li>

              <li
                className={`nav-item ${
                  activeLink === "/services" ? "active" : ""
                }`}
              >
                <Nav.Link href="#events">Events</Nav.Link>
              </li>

              <li
                className={`nav-item ${
                  activeLink === "/pricing" ? "active" : ""
                }`}
              >
                <Nav.Link href="#packages">Packages</Nav.Link>
              </li>

              <li
                className={`nav-item ${
                  activeLink === "/howto" ? "active" : ""
                }`}
              >
                <Nav.Link href="#howto">How To Use</Nav.Link>
              </li>

              <li
                className={`nav-item ${
                  activeLink === "/aboutus" ? "active" : ""
                }`}
              >
                <Nav.Link href="#aboutus">About Us</Nav.Link>
              </li>

              <li
                className={`nav-item ${
                  activeLink === "/contact" ? "active" : ""
                }`}
              >
                <Nav.Link href="#contactus">Contact Us</Nav.Link>
              </li>

              <li className="nav-item navbar-cta-group ms-lg-auto">
                <Nav.Link
                  href="https://app.theendlessmoment.com/auth/signup"
                  className="p-0"
                >
                  <Button as="span" className="btn btn-custom">
                    Try Demo
                  </Button>
                </Nav.Link>
                <Nav.Link
                  href="https://app.theendlessmoment.com"
                  className="p-0 me-0"
                >
                  <Button as="span" className="btn btn-custom">
                    Login
                  </Button>
                </Nav.Link>
              </li>
            </ul>
          </Navbar.Collapse>
        </Container>
      </nav>
    </React.Fragment>
  );
};

export default NavBar;
